import * as React from "react";
import { formSet, useCpFormAnyValueId } from "../../gvc/testNewForm/utils";
import { BasePathContext, useBasePath } from "../../../reactContexts/basePathContext";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ContentLayout } from "../../../components/layout/contentLayout";
import { SingleNavMenuLink, toLinkButton, toLinkPage, toLinkSpace } from "../../identity/useNavMenu";
import { useAppDispatch } from "../../../store/hooks";
import { setRedirect } from "../../../store/contextSlice";
import { IS_DEPLOYMENT_ENV_PROD, IS_LOCAL } from "../../../envVariables";
import { SingleNavMenu } from "../../../components/antd/layout/singleNavMenu";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpTagsNew } from "../../../components/form/CpTagsNew";
import { General } from "./general";
import { CpRootError } from "../../gvc/testNewForm/CpRootError";

interface Props {
  ignoreBlockerRef: React.RefObject<boolean>;
}
export const LocationCreateContent: React.FC<Props> = ({ ignoreBlockerRef }) => {
  const dispatch = useAppDispatch();
  const basePath = useBasePath(`/location/-create/*`);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { id: formId, submit } = useCpFormContext();

  const submitting = useCpFormAnyValueId(formId, `meta.submitting`);

  React.useEffect(() => {
    const startingPage = `${basePath}/general`;
    navigate(startingPage, { replace: true });
  }, []);

  const links = React.useMemo(() => {
    const links: SingleNavMenuLink[] = [];
    links.push(
      //
      toLinkPage("Location", "/general", { names: [`name`, `description`] }),
      toLinkPage("Tags", "/tags", { names: ["tags"] }),
      toLinkSpace(),
      toLinkButton("Cancel", {
        type: "primary",
        onClick: () => {
          ignoreBlockerRef.current = true;
          const back = pathname.split(`/-create`)[0];
          dispatch(setRedirect(back));
        },
        disabled: submitting,
        danger: true,
      }),
      toLinkButton("Preview", {
        type: "default",
        onClick: () => formSet(formId, `meta.previewing`, true),
        disabled: submitting,
      }),
      toLinkButton("Create", {
        type: "primary",
        onClick: async () => {
          await submit();
        },
        loading: submitting,
        disabled: submitting,
        className: "action",
      }),
    );

    if (IS_LOCAL || !IS_DEPLOYMENT_ENV_PROD) {
      links.push(
        toLinkButton("Debug", {
          type: "default",
          onClick: () => formSet(formId, `meta.debugging`, true),
        }),
      );
    }

    return links;
  }, [submitting]);

  return (
    <BasePathContext.Provider value={basePath}>
      <ContentLayout
        nav={<SingleNavMenu useDetailHeader={false} links={links} />}
        content={
          <div className="cpln-cards-container">
            <CpRootError />
            <Routes>
              <Route path={`general/*`} element={<General />} />
              <Route path={`tags/*`} element={<CpTagsNew />} />
            </Routes>
          </div>
        }
      />
    </BasePathContext.Provider>
  );
};
